<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="getData"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="delname"
                label="经销商"
                align="center"
                width="140"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="legalPersonaName"
                label="法人姓名"
                align="center"
                width="90"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="legalPersonaWechat"
                label="法人微信"
                align="center"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="name"
                label="企业名称"
                align="center"
                width="140"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="code"
                label="企业代码"
                align="center"
                min-width="140"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="time"
                label="申请时间"
                align="center"
                width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="username"
                label="申请人"
                align="center"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="tel"
                label="联系电话"
                align="center"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="状态"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="info">未提交</el-tag>
                  <el-popover
                    v-if="scope.row.mark===1"
                    placement="top"
                    width="300"
                    trigger="hover">
                    <div style="font-weight: bold;margin-bottom: 10px">审核信息</div>
                    <div>{{scope.row.rson}}</div>
                    <el-tag :disable-transitions="true" size="mini" type="warning" slot="reference"><i class="el-icon-question"></i> 审核中</el-tag>
                  </el-popover>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">审核通过</el-tag>
                  <el-popover
                    v-if="scope.row.mark===3"
                    placement="top"
                    width="300"
                    trigger="hover">
                    <div style="font-weight: bold;margin-bottom: 10px">拒绝原因</div>
                    <div>{{scope.row.rson}}</div>
                    <el-tag :disable-transitions="true" size="mini" type="danger" slot="reference"><i class="el-icon-question"></i> 审核拒绝</el-tag>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-document" size="mini" @click="edit(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="代注册小程序申请"
      :visible.sync="fasteDrawer"
      width="500px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="regForm" :model="regForm" :rules="regRules" label-position="right" label-width="auto" size="small">
        <el-form-item label="法人姓名" prop="legal_persona_name">
          <el-input :disabled="regMark===1||regMark===2" v-model="regForm.legal_persona_name" maxlength="10" />
          <span style="font-size: 12px;color:#9aaabf">法人姓名需与绑定微信银行卡的姓名一致</span>
        </el-form-item>
        <el-form-item label="法人微信" prop="legal_persona_wechat">
          <el-input :disabled="regMark===1||regMark===2" v-model="regForm.legal_persona_wechat" maxlength="100" />
          <span style="font-size: 12px;color:#9aaabf">需使用绑定法人银行卡号的微信号</span>
        </el-form-item>
        <el-form-item label="企业名称" prop="name">
          <el-input :disabled="regMark===1||regMark===2" v-model="regForm.name" maxlength="100" />
          <span style="font-size: 12px;color:#9aaabf">企业名称需与工商部门登记信息一致</span>
        </el-form-item>
        <el-form-item label="企业代码类型" prop="code_type">
          <el-select :disabled="regMark===1||regMark===2" v-model="regForm.code_type" style="width: 100%">
            <el-option label="统一社会信用代码（18 位）" :value="1" />
            <el-option label="组织机构代码（9 位 xxxxxxxx-x）" :value="2" />
            <el-option label="营业执照注册号(15 位)" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="企业代码" prop="code">
          <el-input :disabled="regMark===1||regMark===2" v-model="regForm.code" maxlength="20" />
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input :disabled="regMark===1||regMark===2" v-model="regForm.tel" maxlength="11" />
        </el-form-item>
        <el-form-item label="当前状态" v-if="regMark!==0">
          <el-tag type="warning" v-if="regMark===1">审核中</el-tag>
          <el-tag type="success" v-if="regMark===2">审核通过</el-tag>
          <el-tag type="danger" v-if="regMark===3">审核拒绝</el-tag>
        </el-form-item>
        <el-form-item label="拒绝原因" v-if="regMark===3">
          <span style="color:#F56C6C;font-weight: bold">{{regRson}}</span>
        </el-form-item>
        <el-form-item v-if="regMark!==1&&regMark!==2" style="text-align: right;">
          <el-button type="primary" :loading="regLoading" @click="submitFasteReg">立即提交</el-button>
          <el-button @click="fasteDrawer=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerRegwxApplyList, subEditDealerRegwxApply } from '@/api/dealer'
import { validatePhoneNumber } from '@/utils/validate'
export default {
  name: 'dzcsq',
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value !== null && value !== '' && value !== undefined) {
        if (this.regForm.code_type === 1) {
          if (value.length === 18) {
            callback()
          } else {
            callback(new Error('请输入正确的统一社会信用代码'))
          }
        } else if (this.regForm.code_type === 2) {
          if (value.length === 9) {
            callback()
          } else {
            callback(new Error('请输入正确的组织机构代码'))
          }
        } else {
          if (value.length === 15) {
            callback()
          } else {
            callback(new Error('请输入正确的营业执照注册号'))
          }
        }
      } else {
        callback(new Error('请输入企业代码'))
      }
    }
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      fasteDrawer: false,
      regLoading: false,
      isReg: false,
      regMark: 0,
      regRson: '',
      regForm: {
        drid: 0,
        delid: '',
        tel: '',
        userid: 0,
        legal_persona_name: '',
        legal_persona_wechat: '',
        name: '',
        code_type: 1,
        code: ''
      },
      regRules: {
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        legal_persona_name: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
        legal_persona_wechat: [{ required: true, message: '请输入法人微信', trigger: 'blur' }],
        name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        code_type: [{ required: true, message: '请选择企业代码类型', trigger: 'change' }],
        code: [{ required: true, trigger: 'blur', validator: validateCode }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const data = {
        search: this.searchForm.search
      }
      this.loading = true
      getDealerRegwxApplyList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    submitFasteReg() {
      if (!this.regLoading) {
        this.$refs['regForm'].validate((valid) => {
          if (valid) {
            this.regLoading = true
            const data = {
              delid: this.regForm.delid,
              userid: this.regForm.userid,
              drid: this.regForm.drid,
              tel: this.regForm.tel,
              legal_persona_name: this.regForm.legal_persona_name,
              legal_persona_wechat: this.regForm.legal_persona_wechat,
              name: this.regForm.name,
              code_type: this.regForm.code_type,
              code: this.regForm.code
            }
            subEditDealerRegwxApply(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.regLoading = false
              this.fasteDrawer = false
              this.getData()
            }).catch(() => {
              this.regLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    edit(row) {
      this.isReg = true
      this.regMark = row.mark
      this.regRson = row.rson
      this.regForm = {
        drid: row.drid,
        delid: row.delid,
        userid: row.userid,
        tel: row.tel,
        legal_persona_name: row.legalPersonaName,
        legal_persona_wechat: row.legalPersonaWechat,
        name: row.name,
        code_type: row.codeType,
        code: row.code
      }
      this.fasteDrawer = true
    }
  }
}
</script>

<style scoped>
</style>
